// extracted by mini-css-extract-plugin
export default {"main":"ReviewsModal_main__jezpq","title":"ReviewsModal_title__rhDLp","reviews":"ReviewsModal_reviews__99WOZ","review":"ReviewsModal_review__Tq2E9"};